export const validateMobile = (currentWidth) => {
  if (currentWidth <= 600) {
    return true;
  }


};